import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Stack, Tooltip, Typography, useTheme } from '@mui/material';
import { _ } from '/@/locale';
import { getRiskDotColor, WEATHER_MODAL_COLORS } from './colors';
import { getPillVariant } from './data';
import type { ApplicationRiskShape } from './types';

const RISK_ORDER: (keyof ApplicationRiskShape)[] = ['drift', 'wash', 'evaporation'];
const RISK_LABELS: Record<keyof ApplicationRiskShape, string> = {
    drift: 'Deriva',
    wash: 'Lavado',
    evaporation: 'Evaporación',
};

const TooltipContent = ({ risk, showDisclaimer }: { risk: ApplicationRiskShape; showDisclaimer: boolean }) => (
    <Box sx={{ py: 0.5 }}>
        <Stack direction='row' spacing={1.5}>
            {RISK_ORDER.map((key) => (
                <Stack key={key} direction='row' spacing={0.5} alignItems='center'>
                    <FiberManualRecordIcon sx={{ fontSize: 8, color: getRiskDotColor(risk[key]) }} />
                    <Typography variant='body2' color='white'>
                        {_(RISK_LABELS[key])}
                    </Typography>
                </Stack>
            ))}
        </Stack>
        {showDisclaimer && (
            <Typography variant='caption' color='white' sx={{ display: 'block', mt: 0.5 }}>
                {_('Requiere ajustes del equipo')}
            </Typography>
        )}
    </Box>
);

const ApplicationPill = ({ risk }: { risk: ApplicationRiskShape }) => {
    const theme = useTheme();
    const variant = getPillVariant(risk);

    const style =
        variant === 'apto'
            ? WEATHER_MODAL_COLORS.pill.apto
            : variant === 'apto-adjust'
              ? WEATHER_MODAL_COLORS.pill.aptoAdjust
              : WEATHER_MODAL_COLORS.pill.noApto;

    const label = variant === 'no-apto' ? _('No apto') : _('Apto');

    return (
        <Tooltip
            arrow
            placement='top'
            title={<TooltipContent risk={risk} showDisclaimer={variant === 'apto-adjust'} />}
            componentsProps={{
                tooltip: { sx: { bgcolor: theme.palette.primary.main, px: 1, py: 0.5 } },
                arrow: { sx: { color: theme.palette.primary.main } },
            }}
        >
            <Box
                component='span'
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.25,
                    bgcolor: style.bg,
                    color: style.text,
                    borderRadius: '20px',
                    px: 0.75,
                    minHeight: 18,
                    cursor: 'default',
                    whiteSpace: 'nowrap',
                }}
            >
                <Typography variant='caption' component='span' fontWeight='bold'>
                    {label}
                </Typography>
                {variant === 'apto-adjust' && <InfoOutlinedIcon sx={{ fontSize: 12 }} />}
            </Box>
        </Tooltip>
    );
};

export default ApplicationPill;
